import React, {Component} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {Container, Header, Segment, Image, Grid,Card, Icon, Loader} from 'semantic-ui-react';
const coverImage = require('../assets/img/desk.jpg');
const cupImage = require('../assets/img/cup.png');
const clientsImage = require('../assets/img/clientes.png');
import {
    Link
  } from 'react-router-dom';
const coverStyle = {
  backgroundColor: '#70B188',
  backgroundImage: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed'
};
const mainSegmentStyle = {
  height: '10vh',
  background: 'rgba(0,0,0,0)',
  backgroundColor: 'hsl(0, 0%, 100%)',
  mixBlendMode: 'screen',
  marginBottom: '50vh'
};
const headerStyle = {
  textTransform: 'uppercase',
  textShadow: 'rgb(152, 152, 152) 9px 4px 0px',  
  color: 'black',

  position: 'absolute',
  bottom: 20,
  width: '100%',
  left: 0,
  right: 0
};
const subheaderStyle = {
  color: 'black',
  textShadow: 'none'
};
const secondaryHeaderStyle = {
  color: 'orange',
  display: 'inline-block',

};
const textStyle = {
  fontSize: '16pt'
}
class ArticleView extends Component {

  constructor(props) {
    super(props);
    this.state = {
        loading: false,
        data: {articles: []},
        error: null
    };
  }

  loadArticles = async () => {
    this.setState({
        loading: true,
        error: null
    });
    let request = new Request('https://s3.us-east-2.amazonaws.com/sistelblog/blog.json');
      try {
        let result = await fetch(request);
        let json = await result.json();
        this.setState({
            data: json,
            loading: false,
            error: null
        });
      } catch (error) {
          this.setState({
            data: {articles: []},
            loading: false,
            error
          })
      } 
  }

  componentDidMount() {
      this.loadArticles();
  }

  render() {
    let {data, loading} = this.state;
    let {articles} = data;
    let article = articles.find(a => a.id == this.props.match.params.articleId) || {title: "", description: "", date: "", body: "", id: this.props.match.params.articleId};
    return (
        <div style={{overflow: "hidden"}}>
        <Container style={{paddingTop: 200, height: "100%", marginRight: "-50px", paddingRight: "50px"}}>
            <div>
            {loading? <Loader active inline="centered"/> : null}
            <Header as="h2">

            {article.title}
            </Header>
            <Header.Subheader as="h3">
                {article.description}<br/>{article.author} {article.description.length > 0 ? "//": null} {article.date}
            </Header.Subheader>
          <Grid
            padded
            relaxed
            stackable
            style={{
            backgroundColor: 'white'
          }}>
          <Grid.Row>
            <Grid.Column>
                <Segment basic padded='very' size='large'>
                    <div dangerouslySetInnerHTML={{__html: article.body}} />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          </div>
                    <div style={{margin: '5px', textAlign: "center", color: "white"}}><strong>Teniente Cundom 1574 - Corrientes - Argentina</strong></div>
        </Container>
        </div>
    );
  }
}

export default ArticleView;

const ArticleSummary = (props) => {
    return (
        <Card fluid as={Link} to={`/blog/${props.id}`}>
            <Card.Content header={props.title} />
            <Card.Content description={props.description} />
            <Card.Content extra>
            <Icon name='user' />
            Por {props.author}, el {props.date}
            </Card.Content>
        </Card>
    );
};




// WEBPACK FOOTER //
// ./client/containers/ArticleView.js